import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the FilterAutoexclusionUsersView.
 * @extends JetView
 */
export default class FilterAutoexclusionUsersView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the form with input fields
        const left = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for ID
                    name: 'Id',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('ID is required'), // Validation message
                },
                {
                    view: 'richselect', // Dropdown for categories
                    name: 'Categorie',
                    localId: 'categorie:combo',
                    label: _("<span class='icon-category'></span> Categorías"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options to be populated
                },
                {
                    view: 'text', // Text input for user creation
                    name: 'UserCreation',
                    label: _("<span class='icon-folder-add'></span> Usuario Creación"),
                    labelPosition: 'top',
                    placeholder: _('Usuario Creación'),
                    invalidMessage: _('Usuario Creación is required'), // Validation message
                },
            ],
        };

        // Center left section of the form with input fields
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for subcategories
                    name: 'SubCategory',
                    localId: 'subCategorie:combo',
                    label: _("<span class='icon-subcategory'></span> Sub Categoría"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options to be populated
                },
                {
                    view: 'text', // Text input for user modified
                    name: 'UserModified',
                    label: _("<span class='icon-mode_edit'></span> Usuario Modificó"),
                    labelPosition: 'top',
                    placeholder: _('Usuario Modificó'),
                    invalidMessage: _('Usuario Modificó is required'), // Validation message
                },
            ],
        };

        // Center right section of the form with input fields
        const center_right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for games
                    name: 'Game',
                    localId: 'game:combo',
                    label: _("<span class='icon-games'></span> Juego"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options to be populated
                },
            ],
        };

        // Right section of the form with input fields
        const right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for activation status
                    name: 'IsActivate',
                    label: _("<span class='icon-state'></span> Estado"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: 'Todos' }, // Option for all
                        { id: 'A', value: 'Activado' }, // Option for activated
                        { id: 'I', value: 'Inactivado' }, // Option for deactivated
                    ],
                },
                {
                    view: 'text', // Text input for datepicker
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Read-only input
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Upper section combining all parts of the form
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_right,
                { gravity: 0, minWidth: 10 }, // Spacer
                right,
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key to trigger
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('autoexclusionUsers:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
